import { createSlice } from '@reduxjs/toolkit';
import IAppStoreState from '../interfaces/IAppStoreState';
import IFellowshipStoreState from '../interfaces/IFellowshipStoreState';
import IFellowshipPost from '../interfaces/IFellowshipPost';
import UnregisterGroup from '../data/UnregisteredGroup';

const FellowshipInitialState: IFellowshipStoreState = {
    posts: [],
    // comments: [],
    group: UnregisterGroup,
    // Note: groupMembers will include information for current members and old members who are no longer part of the group
    // to find a list of active members go to group.memberIds, this was done to improve indexing and store group member info
    // after a member left the group
    groupMembers: null,
    activeGroupId: undefined,
    groups: null,
    groupIds: [],
    loadNewGroup: false,
    fellowshipLoaded: false,
} 

const FellowshipSlice = createSlice({
    name: 'Fellowship',
    initialState: FellowshipInitialState,
    reducers: {
        AddPosts: (state, action) => {
            state.posts = [...state.posts, ...action.payload];
            return state;
        },
        UpdatePosts: (state, action) => {
            state.posts = combineWithoutDuplicates(state.posts, action.payload) as IFellowshipPost[];;
            return state;
        },
        UpdatePost: (state, action) => {
            const posts = [...state.posts];
            const postIndex = posts.findIndex(post => post.id === action.payload.id);
            posts[postIndex] = action.payload;
            state.posts = posts;
        },
        ResetPosts: (state) => {
            state.posts = [];
        },
        UpdateGroup: (state, action) => {
            state.group = {...action.payload};
            state.activeGroupId = state.group.id;
            const groupMembers = state.group.memberInfo.map(member => (
                {[member.userId]: {displayName: member.displayName, role: member.role}})
            );
            state.groupMembers = Object.assign({}, ...groupMembers);

            if(state.groups && state.groups.hasOwnProperty(action.payload?.id)) {
                state.groups[action.payload.id].group = {...action.payload};
                state.groups[action.payload.id].groupMembers = Object.assign({}, ...groupMembers);
                state.groupIds = state.groups ? Array.from(Object.keys(state.groups)) :  [];
                console.log('GroupId-fs1', state.groups);
            }
            return state;
        },
        UpdateActiveGroupId: (state, action) => {
            state.activeGroupId = action.payload;
            if(state.groups && state.groups.hasOwnProperty(action.payload)) {
                state.group = {...state.groups[action.payload].group}
                state.groupMembers = {...state.groups[action.payload].groupMembers}
            }
            return state;
        },
        UpdateGroups: (state, action) => {
            const groups = {...action.payload};
            console.log('GroupId-fs', groups);
            state.groups = groups;
            state.groupIds = groups ? Array.from(Object.keys(groups)) :  [];
            return state;
        },
        UpdateLoadNewGroup: (state, action) => {
            state.loadNewGroup = action.payload;
            return state;
        },
        UpdateFellowshipLoaded: (state, action) => {
            console.log('Auth State Changed groupids', action.payload, state.fellowshipLoaded);
            state.fellowshipLoaded = action.payload;
            return state;
        },
        LogoutOfAllGroups: (state) => {
            state.group = {...UnregisterGroup};
            state.activeGroupId = UnregisterGroup.id;
            state.groupMembers = null;        
            state.groups = null;
            state.groupIds = [];
            return state;
        },
    }
});

const { actions, reducer } = FellowshipSlice;

//Actions Export
export const { UpdatePosts, 
    AddPosts, 
    UpdatePost, 
    // LoadComments, CreateComment, UpdateComment, 
    ResetPosts, 
    UpdateGroup,
    UpdateGroups,
    UpdateActiveGroupId,
    UpdateLoadNewGroup,
    UpdateFellowshipLoaded,
    LogoutOfAllGroups,
} = actions;

//Selector Export
export const SelectPosts = (state: IAppStoreState) => {
    const sortedPosts = [...state.Fellowship.posts];
    return sortedPosts.sort((a, b) => 
    a.sortDate! < b.sortDate! ? 1 :
    a.sortDate! > b.sortDate! ? -1 : 0);
}

export const SelectPost = (postId: string) => {
    return (state: IAppStoreState) => {
        return state.Fellowship.posts.find(post => post.id === postId)
    }
}

export const SelectGroup = (state: IAppStoreState) => (state.Fellowship.group);

// Note: this will include information for current members and old members who are no longer part of the group
export const SelectGroupMembers = (state: IAppStoreState) => (state.Fellowship.groupMembers);
export const SelectGroups = (state: IAppStoreState) => (state.Fellowship.groups);
export const SelectGroupIds = (state: IAppStoreState) => (state.Fellowship.groupIds);
export const SelectActiveGroupId = (state: IAppStoreState) => (state.Fellowship.activeGroupId);
export const SelectLoadNewGroup = (state: IAppStoreState) => (state.Fellowship.loadNewGroup);
export const SelectFellowshipLoaded = (state: IAppStoreState) => (state.Fellowship.fellowshipLoaded);
export const SelectIsGroupAdmin = (state: IAppStoreState) => (state.Fellowship?.group?.creatorId === state.UserAccount?.User?.id);

//Reducer Export
export default reducer;


function combineWithoutDuplicates(oldArray: Array<IFellowshipPost>, newArray: Array<IFellowshipPost>)  {
    const onlyOldItemsArray = [...oldArray.filter(oldItem => 
        !(!!newArray.find(newItem => newItem.id === oldItem.id)))];
    const combinedArray = [...onlyOldItemsArray, ...newArray];
    
    // Prevent the sortDate from being altered in the UI
    // This keeps old posts from disappear and reappearing at the top 
    // when someone is flipping through and reading them.
    // However, it does make old updated posts pop up to the top when they
    // open the app at first and posts have been updated.
    return combinedArray.map(post => {
        const oldPost = oldArray.find(oldPost => oldPost.id === post.id);
        return oldPost ? {...post, sortDate: oldPost.sortDate} : post;
    });
}